import styled, {css} from "styled-components"

import {
  ConfirmRemoveRecognition as ConfirmRemoveRecognitionBase,
  ConfirmArchiveRecognition as ConfirmArchiveRecognitionBase,
  ConfirmRemoveScheduledRecognition as ConfirmRemoveScheduledRecognitionBase
} from "./Confirm"

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`

const styles = css`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: ${({theme}) => theme.spacing.four};
  text-align: left;
  z-index: 10;
`

const ConfirmRemoveRecognition = styled(ConfirmRemoveRecognitionBase)`
  ${styles}
`
const ConfirmRemoveScheduledRecognition = styled(ConfirmRemoveScheduledRecognitionBase)`
  ${styles}
  right: unset;
  left: 0;
`
const ConfirmArchiveRecognition = styled(ConfirmArchiveRecognitionBase)`
  ${styles}
`

export {ActionsWrapper, ConfirmRemoveRecognition, ConfirmArchiveRecognition, ConfirmRemoveScheduledRecognition}
